import { types, async } from "../utils/type-creator";

export default types(
  [...async("LIST"), ...async("UPDATE"), ...async("CREATE"), ...async("CREATE_PASSWORD")],
  "USERS"
);
